var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd-top-15"},[_c('page-layout',{attrs:{"breadcrumbs":[
      {
        text: this.$t('navDrawer.home').toUpperCase(),
        disabled: false,
        to: {name: 'home'},
        exact: true
      },
      {
        text: _vm.localization.title.toUpperCase(),
        disabled: true
      }
    ]}},[(_vm.loading)?_c('o-main-progress'):_c('v-row',{staticClass:"py-2",attrs:{"wrap":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-tabs',{staticClass:"transparentTabs",attrs:{"id":"seccionActual","grow":"","color":"primary","background-color":"transparent"},model:{value:(_vm.seccionActual),callback:function ($$v) {_vm.seccionActual=$$v},expression:"seccionActual"}},[_vm._l((_vm.items),function(item,index){return _c('v-tab',{key:index + '-tab'},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),_vm._l((_vm.items),function(item,index){return _c('v-tab-item',{key:index + '-tab-item'},[_c('v-container',{attrs:{"fluid":""}},[_c(item.tipo,{tag:"component"})],1)],1)})],2)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }